import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($options.iconClasses)
  }, [
    _createVNode(_component_base_icon, {
      name: $props.icon,
      class: "_flex"
    }, null, 8 /* PROPS */, ["name"])
  ], 2 /* CLASS */))
}